//import { APIResponse, APIResponseDtoImpl } from '../apiresponse';
import { MiddlewareAPIResponse } from '../middlewareapiresponse';
import { MiddlewareDtoImpl } from '../../dto/middlewaredto';

export interface PasswordValidationCCResponse extends MiddlewareAPIResponse   //APIResponse
{
    getRefreshToken(): string;   
    getAccessToken(): string;   
    getExpiry(): number;   
    getMsisdn(): string;   
    getDeviceId(): string;   
    getSettings(): any;   
}

export class PasswordValidationCCResponseDtoImpl extends MiddlewareDtoImpl /* APIResponseDtoImpl */ implements PasswordValidationCCResponse
{
    private refreshToken: string;
    private accessToken: string;
    private expiry: number;
    private msisdn: string;
    private deviceId: string;
    private settings: any;

    getRefreshToken(): string
    {
        return this.refreshToken;
    }
    setRefreshToken(refreshToken: string)
    {
        this.refreshToken = refreshToken;
    }

    getAccessToken(): string
    {
        return this.accessToken;
    }
    setAccessToken(accessToken: string)
    {
        this.accessToken = accessToken;
    }

    getExpiry(): number
    {
        return this.expiry;
    }
    setExpiry(expiry: number)
    {
        this.expiry = expiry;
    }

    getMsisdn(): string
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getDeviceId(): string
    {
        return this.deviceId;
    }
    setDeviceId(deviceId: string)
    {
        this.deviceId = deviceId;
    }

    getSettings(): any
    {
        return this.settings;
    }
    setSettings(settings: any)
    {
        this.settings = settings;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/passwordvalidationcc/passwordvalidationccresponse.tsx